import styled from 'styled-components'

export const ContentSuggestionModal = styled.div`
  background: var(--light);
  border-radius: 20px 20px 0 0;
  padding: 1.8rem 0;
  width: 100%;
  max-width: 100%;
  overflow: visible;
  min-height: 40vh;

  /* Desktop: border-radius completo e largura limitada */
  @media only screen and (min-width: 768px) {
    border-radius: 20px;
    width: 100%;
    max-width: 600px;
  }

  button {
    background-color: transparent;
  }

  form {
    padding: 1.5rem 2.25rem 0 2.25rem;
    overflow: visible;

    @media only screen and (max-width: 480px) {
      padding: 1.5rem 1.5rem 0 1.5rem;
      overflow: visible;
    }
  }
`

export const ModalHeader = styled.div`
  border-bottom: 1px solid var(--grey4);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 2.25rem 1.56rem 2.25rem;

  @media only screen and (max-width: 480px) {
    padding: 0 1.5rem 1.56rem 1.5rem;
  }

  p {
    color: var(--dark);
    font-size: 1.25rem;
    font-weight: 600;
    line-height: 1.4;
    padding-right: 1rem;

    @media only screen and (max-width: 480px) {
      font-size: 1.125rem;
    }
  }

  button {
    flex-shrink: 0;
    color: var(--grey14);

    &:hover {
      opacity: 0.7;
    }
  }
`

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 1.5rem;

  label {
    color: var(--grey2);
    font-size: 0.875rem;
    font-weight: 500;
    margin-bottom: 0.5rem;

    .required {
      color: var(--red);
    }
  }
`

export const Input = styled.input`
  padding: 0.75rem 1rem;
  border: 1px solid var(--grey11);
  border-radius: 8px;
  font-size: 0.875rem;
  color: var(--dark);
  transition: border-color 0.2s;

  &:focus {
    outline: none;
    border-color: var(--blue);
  }

  &::placeholder {
    color: var(--grey3);
    font-size: 14px;
    font-weight: 300;
    font-style: italic;
  }

  @media only screen and (max-width: 400px) {
    font-size: 12px;

    &::placeholder {
      font-size: 12px;
    }
  }
`

export const Select = styled.select`
  padding: 0.75rem 1rem;
  border: 1px solid var(--grey11);
  border-radius: 8px;
  font-size: 0.875rem;
  color: var(--dark);
  background-color: var(--light);
  cursor: pointer;
  transition: border-color 0.2s;
  width: 100%;
  max-width: 100%;

  &:focus {
    outline: none;
    border-color: var(--blue);
  }

  option {
    padding: 0.5rem;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  @media only screen and (max-width: 480px) {
    font-size: 12px;
    /* Garante que o dropdown não ultrapasse os limites da tela */
    position: relative;
    z-index: 1;
  }

  @media only screen and (max-width: 400px) {
    font-size: 12px;
  }
`

export const Textarea = styled.textarea`
  padding: 0.75rem 1rem;
  border: 1px solid var(--grey11);
  border-radius: 8px;
  font-size: 0.875rem;
  color: var(--dark);
  font-family: inherit;
  resize: vertical;
  min-height: 100px;
  transition: border-color 0.2s;

  &:focus {
    outline: none;
    border-color: var(--blue);
  }

  &::placeholder {
    color: var(--grey3);
    font-size: 14px;
    font-weight: 300;
    font-style: italic;
  }

  @media only screen and (max-width: 400px) {
    font-size: 12px;

    &::placeholder {
      font-size: 12px;
    }
  }
`

export const CharCount = styled.span`
  font-size: 0.75rem;
  color: var(--grey14);
  text-align: right;
  margin-top: 0.25rem;
`

export const ButtonGroup = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 2rem;
`

interface SubmitButtonProps {
  $isValid: boolean
}

export const SubmitButton = styled.button<SubmitButtonProps>`
  width: 100%;
  height: 40px;
  border-radius: 5px;
  font-size: 0.875rem;
  font-weight: 500;
  background-color: #5e48e8 !important;
  color: var(--light);
  transition: all 0.2s;
  cursor: ${props => (props.$isValid ? 'pointer' : 'not-allowed')};
  opacity: ${props => (props.$isValid ? 1 : 0.2)};
  border: none;

  &:hover {
    opacity: ${props => (props.$isValid ? 0.9 : 0.2)};
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.2;
  }
`

// Estilos para o CustomSelect
export const CustomSelectContainer = styled.div`
  position: relative;
  width: 100%;
`

interface CustomSelectButtonProps {
  required?: boolean
}

export const CustomSelectButton = styled.button<CustomSelectButtonProps>`
  width: 100%;
  padding: 0.75rem 1rem;
  border: 1px solid var(--grey11);
  border-radius: 8px;
  font-size: 0.875rem;
  color: var(--dark);
  background-color: var(--light);
  cursor: pointer;
  transition: border-color 0.2s;
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-align: left;

  &:focus {
    outline: none;
    border-color: var(--blue);
  }

  @media only screen and (max-width: 400px) {
    font-size: 12px;
  }
`

interface CustomSelectTextProps {
  hasValue: boolean
}

export const CustomSelectText = styled.span<CustomSelectTextProps>`
  color: ${props => (props.hasValue ? 'var(--dark)' : 'var(--grey3)')};
  font-size: ${props => (props.hasValue ? '0.875rem' : '14px')};
  font-weight: ${props => (props.hasValue ? '400' : '300')};
  font-style: ${props => (props.hasValue ? 'normal' : 'italic')};
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

interface CustomSelectArrowProps {
  isOpen: boolean
}

export const CustomSelectArrow = styled.div<CustomSelectArrowProps>`
  display: flex;
  align-items: center;
  transition: transform 0.2s;
  transform: ${props => (props.isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
  color: var(--grey14);
  margin-left: 0.5rem;
`

interface CustomSelectDropdownProps {
  isOpen: boolean
}

export const CustomSelectDropdown = styled.div<CustomSelectDropdownProps>`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 1000;
  background-color: var(--light);
  border: 1px solid var(--grey11);
  border-radius: 8px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  margin-top: 0.25rem;
  opacity: ${props => (props.isOpen ? 1 : 0)};
  visibility: ${props => (props.isOpen ? 'visible' : 'hidden')};
  transform: ${props => (props.isOpen ? 'translateY(0)' : 'translateY(-10px)')};
  transition: all 0.2s ease-in-out;
  max-height: 200px;
  overflow-y: auto;

  /* Garante que o dropdown seja exibido corretamente no mobile */
  @media only screen and (max-width: 480px) {
    position: fixed;
    top: auto;
    left: 50%;
    right: auto;
    transform: ${props =>
      props.isOpen
        ? 'translateX(-50%) translateY(0)'
        : 'translateX(-50%) translateY(-10px)'};
    width: calc(100vw - 2rem);
    max-width: calc(100vw - 44px);
    z-index: 1001;
  }
`

export const CustomSelectList = styled.div`
  padding: 0.25rem 0;
`

interface CustomSelectOptionProps {
  isSelected: boolean
}

export const CustomSelectOption = styled.button<CustomSelectOptionProps>`
  width: 100%;
  padding: 0.5rem 1rem;
  text-align: left;
  background-color: ${props =>
    props.isSelected ? 'rgba(94, 72, 232, 0.1)' : 'transparent'};
  color: ${props => (props.isSelected ? 'var(--blue)' : 'var(--dark)')};
  transition: background-color 0.15s;
  cursor: pointer;
  border: none;
  outline: none;
  font-size: 0.875rem;
  display: block;

  &:hover {
    background-color: ${props =>
      props.isSelected ? 'rgba(94, 72, 232, 0.1)' : 'var(--grey4)'};
  }

  &:focus {
    background-color: var(--grey4);
  }

  @media only screen and (max-width: 400px) {
    font-size: 12px;
  }
`
